<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
  #app {
    width: 100%;
    height: 100%;
  }
@import './style/index.scss';
@import url('//at.alicdn.com/t/font_1161680_bnl9k3siwmp.css');
</style>



// WEBPACK FOOTER //
// src/App.vue